import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetSupplierInvoiceApi } from "../../ApiRequests";

export const fetchRMStockStats = createAsyncThunk(
  "fetch/RMStockStats",
  async () => {
    try {
      const response = await GetSupplierInvoiceApi();
      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const RMStockStatsSlice = createSlice({
  name: "RMStockStats",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRMStockStats.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchRMStockStats.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchRMStockStats.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default RMStockStatsSlice.reducer;
